import { defineComponent, openBlock, createBlock, Teleport, renderSlot } from 'vue';

var script = defineComponent({
  name: 'OrTeleport',
  props: {
    to: {
      type: String,
      default: 'body'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Teleport, {
    to: _ctx.to,
    disabled: _ctx.disabled
  }, [renderSlot(_ctx.$slots, "default")], 8 /* PROPS */, ["to", "disabled"]);
}

script.render = render;
script.__file = "src/components/or-teleport-v3/OrTeleport.vue3.vue";

export { script as OrTeleportV3 };
